// formkit.config.js
import { de } from '@formkit/i18n'
import { generateClasses } from '@formkit/themes'
import TailwindTheme from './tailwind-theme.js'

export default {

  //initalize german locale
  locales: {de},
  locale: 'de',

  config: {
    classes: generateClasses(TailwindTheme),
    locales: {
      de: {
        validation: {
          // overwrite the default message for the required rule
          required({ name }) {
            return `${name[0].toUpperCase() + name.substr(1)} ist ein Pflichtfeld.`
          },
        }
      }
    }
  },
}
